import React from 'react';
import PropTypes from 'prop-types';
import VoiceMultiSelectFilter from './VoiceMultiSelectFilter';
import { captureAnalytics } from '../../../actions/preload';

// ENG-3107: the inbound "Results Delivered" filter. A thin wrapper over
// VoiceMultiSelectFilter, like VoiceStatusFilter and DepartmentFilter, so the
// subheader controls keep identical markup, compact 32px sizing and tag-overflow
// behaviour instead of drifting; owns the rollout analytics and sends the
// `result_delivery` query param.
//
// `options` are supplied by the API, never hardcoded here. VoiceInbound owns the
// decision not to render this at all when that list is empty — see the invariant
// documented at its selectedResultDelivery state declaration.
const ResultDeliveryFilter = ({
  updateQuery,
  selectedStates,
  setSelectedStates,
  options,
}) => {
  // Rollout observability: PR 6's runbook needs to know whether anyone actually used
  // this control on the first enabled org. Fires only when the selection grows, so
  // clearing chips doesn't inflate the metric. Sends state values only — never a
  // caller name, DOB or any other row content.
  const handleChange = (next) => {
    const selectedStateSet = new Set(selectedStates);
    const added = next.filter((value) => !selectedStateSet.has(value));
    setSelectedStates(next);
    if (added.length) {
      captureAnalytics('result_delivery_filter_applied', {
        added,
        states: next,
        count: next.length,
      });
    }
  };

  return (
    <VoiceMultiSelectFilter
      updateQuery={updateQuery}
      queryKey="result_delivery"
      placeholder="Results Delivered"
      value={selectedStates}
      setValue={handleChange}
      options={options}
      minWidth="180px"
      selectionType="delivery outcomes"
    />
  );
};

ResultDeliveryFilter.defaultProps = {
  updateQuery: () => {},
  selectedStates: [],
  setSelectedStates: () => {},
  options: [],
};

ResultDeliveryFilter.propTypes = {
  updateQuery: PropTypes.func,
  selectedStates: PropTypes.arrayOf(PropTypes.string),
  setSelectedStates: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
};

export default ResultDeliveryFilter;
